import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import { Link } from 'react-router-dom';

import CarouselArrow from 'Components/Carousel/CarouselArrow';
import CarouselPaging from 'Components/Carousel/CarouselPaging';
import ProductCover from 'Components/Utility/ProductCover';
import useViewport from 'Hooks/useViewport';

import 'Components/Carousel/FeaturedCarouselPanels/PanelComponents/ScreenshotCarousel.scss';

const HitsCarousel = ({
  autoPlay,
  hits,
  slideRows,
  switchCoverImg,
  type,
}) => {
  const { isBelowXxl } = useViewport();

  if (isEmpty(hits)) return false;

  let slidesToShow = 2;
  if (type === 'product') slidesToShow = 2;

  let numberOfRows = slideRows;
  if (isBelowXxl && slideRows === 2) {
    numberOfRows = 1;
  }


  // Splitting the slides into columns depending on how many rows we want to show
  let carouselSlides = cloneDeep(hits);
  if (numberOfRows === 2) {
    carouselSlides = carouselSlides.slice(0, 8);
  }
  const slides = [];
  while (carouselSlides.length > 0) {
    slides.push(carouselSlides.splice(0, numberOfRows));
  }

  if (!isEmpty(slides) && slides.length === 1) return false;

  const settings = {
    infinite: true,
    prevArrow: <CarouselArrow ariaLabel="Previous" arrowDirection="left" containerClassName="arrow-btn-container" />,
    nextArrow: <CarouselArrow ariaLabel="Next" arrowDirection="right" containerClassName="arrow-btn-container" />,
    slidesToShow,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: '0px',
    dots: false,
    arrows: true,
    lazyLoad: true,
    autoplay: autoPlay,
    autoplaySpeed: 3000,
    speed: 300,
    accessibility: true,
    customPaging: i => (
      <CarouselPaging slideIndex={i} slideLength={slides.length} slidesToShow={slidesToShow} />
    ),
  };

  return (
    <Slider {...settings} className="ScreenshotCarousel CarouselPanel__section">
      {!isEmpty(slides) && slides.map((slide, i) => {
        const key = `${slide[0].cover}${i}`;

        return (
          <div className="ScreenshotCarousel__column" key={key}>
            <div
              className="ScreenshotCarousel__imgContainer"
              onMouseEnter={() => {
                switchCoverImg({ cover: slide[0].cover, hit: slide[0], type: slide[0].type });
              }}
              onMouseLeave={() => { switchCoverImg(); }}
            >
              {type === 'category' &&
                <Link to={`${slide[0].type}/${slide[0].slug}`}>
                  <ProductCover
                    thumbnail
                    cover={slide[0].cover}
                    alt={`Product cover for ${slide[0].name}`}
                    displayType={slide[0].type}
                  />
                </Link>
              }
              {type !== 'category' &&
                <ProductCover
                  thumbnail
                  cover={slide[0].cover}
                  alt={`Product cover for ${slide[0].name}`}
                  displayType={slide[0].type}
                />
              }
              <div className="ScreenshotCarousel__imgContainer__leftBorder" />
              <div className="ScreenshotCarousel__imgContainer__rightBorder" />
            </div>
            {numberOfRows > 1 && slide[1] &&
              <div
                className="ScreenshotCarousel__imgContainer"
                key={slide[1].cover}
                onMouseEnter={() => {
                  switchCoverImg({ cover: slide[1].cover, hit: slide[1], type: slide[1].type });
                }}
                onMouseLeave={() => { switchCoverImg(); }}
              >
                <Link to={`${slide[1].type}/${slide[1].slug}`}>
                  <ProductCover
                    thumbnail
                    cover={slide[1].cover}
                    alt={`Product cover for ${slide[1].name}`}
                    displayType={slide[1].type}
                  />
                </Link>
                <div className="ScreenshotCarousel__imgContainer__leftBorder" />
                <div className="ScreenshotCarousel__imgContainer__rightBorder" />
              </div>
            }
          </div>
        );
      },
      )}
    </Slider>
  );
};

HitsCarousel.propTypes = {
  autoPlay: PropTypes.bool,
  hits: PropTypes.arrayOf(PropTypes.shape()),
  slideRows: PropTypes.number,
  switchCoverImg: PropTypes.func,
  type: PropTypes.string,
};

HitsCarousel.defaultProps = {
  autoPlay: false,
  hits: [],
  slideRows: 1,
  switchCoverImg: () => {},
  type: '',
};

export default HitsCarousel;
